'use client'

import type { ReactNode } from 'react'
import { THEME_BOOT_SCRIPT } from '../_lib/theme'
import { useTheme } from '../_lib/theme-client'

/**
 * The themed wrapper every Gradient page renders inside. The inline script
 * resolves the theme before first paint; React adopts that value after
 * hydration (suppressHydrationWarning keeps the DOM's attribute meanwhile).
 */
export default function GdRoot({ className, children }: { className: string; children: ReactNode }) {
  const theme = useTheme()
  return (
    <div className={`gd-root ${className}`} data-theme={theme} suppressHydrationWarning>
      <script
        type={typeof window === 'undefined' ? 'text/javascript' : 'text/plain'}
        suppressHydrationWarning
        dangerouslySetInnerHTML={{ __html: THEME_BOOT_SCRIPT }}
      />
      {children}
    </div>
  )
}
